import { useAuth } from "../../../hooks/useAuth";
import TicketsTable from "../Tickets/TicketsTable/TicketsTable";
import { useNavigate } from "react-router-dom";

/**
 * My Tickets Page Component
 * Shows only tickets created by the current user
 */
const MyTickets = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div style={{
            padding: "20px",
            background: "#f8f9fa",
            minHeight: "100vh",
            width: "100%"
        }}>
            {/* Modern Header */}
            {/* <div style={{
                background: "white",
                padding: "24px",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: "24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}>
                <div>
                    <h1 style={{
                        margin: 0,
                        fontSize: "28px",
                        fontWeight: "700",
                        color: "#2c3e50",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <i className="las la-user-circle" style={{ color: "#3bac75" }} />
                        My Tickets
                    </h1>
                    <p style={{
                        margin: "8px 0 0 0",
                        color: "#6c757d",
                        fontSize: "14px"
                    }}>
                        View and manage your support tickets
                    </p>
                </div>
                
                <button
                    onClick={() => navigate("/add-new-ticket")}
                    style={{
                        background: "linear-gradient(135deg, #3bac75 0%, #2d8a5a 100%)",
                        color: "white",
                        border: "none",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        boxShadow: "0 4px 12px rgba(59, 172, 117, 0.3)",
                        transition: "all 0.2s"
                    }}
                    onMouseOver={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 16px rgba(59, 172, 117, 0.4)";
                    }}
                    onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 12px rgba(59, 172, 117, 0.3)";
                    }}
                >
                    <i className="las la-plus-circle" />
                    Create New Ticket
                </button>
            </div> */}

            {/* My Tickets Table */}
            <div style={{
                background: "white",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                overflow: "hidden"
            }}>
                <TicketsTable showAll={false} view="my" />
            </div>
        </div>
    );
};

export default MyTickets;
